module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAeCAYAAADQBxWhAAABZUlEQVRIie2WwXGEMAxFxU4acAu0sC3QwrZAC7SwLZAStgW2BNJCSiAlvBywJ0bIGJOQS/IvzNjSl7HkL4kUArgCAzNG4FrKURqwBiaWmIC6hOdSGPcmIk6tOb9+WtBdAFqfggHo9jqEKxwAF+3V2Ggim97Yf2wFbHIO6lAArdpLoV1HnJ06y3rjgE6tWX8Z0Ae7F8X1YfC/W0Grqnoay5Z/HsxvL8buykykJ6DJObf+qoven/e1UtTHNlUp6c7AjYgEpXpLpOIvgFnAH8xv734Cv/NPafJxnPDVMQLyslUWVBfWQ4xKS0vWsaD6p7iIiK6sn640zfca3/lASh+/CX/Fg//q1viPX4B/u8W6qzjqrMh7Q8eyyxwqLJbNfNwsnkSHKK421hPjQnBOGcxkPTGmwXqu7Q0bF6nMYnCLbO4RR34u9qQdiYmB9RxkyiZw4+AgYJFpLR1LOY7k9GytthFr6RH/T+zPwcCj1pM4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home2_appdev.png
// module id = HGbe
// module chunks = 1